import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { PlayPause } from '../../icons';
import '../styles.scss';

const formatTime = time => {
  const min = Math.floor(time / 60);
  const sec = Math.floor(time % 60);
  return `${min}:${sec < 10 ? `0${sec}` : sec}`;
};

const Recording = ({ sid }) => {
  const audioEl = useRef(null);
  const seekBarEl = useRef(null);
  const [duration, setDuration] = useState('0:00');
  const [loading, setLoading] = useState(true);
  const [currentTime, setCurrentTime] = useState('0:00');
  const [isPlaying, setIsPlaying] = useState(false);
  const [cachedSource, setCachedSource] = useState('');

  const onPlayButtonClick = () => {
    if (audioEl.current) {
      setIsPlaying(!isPlaying);
      if (isPlaying) {
        audioEl.current.pause();
      } else {
        audioEl.current.play();
      }
    }
  };

  const onLoadedMetadata = event => {
    setDuration(formatTime(event.currentTarget.duration));
  };

  const onTimeUpdate = e => {
    const time = e.currentTarget.currentTime;
    setCurrentTime(formatTime(time));
    seekBarEl.current.min = e.currentTarget.startTime;
    seekBarEl.current.max = e.currentTarget.duration;
    seekBarEl.current.value = time;
  };

  const onSeekBarChange = e => {
    const value = e.currentTarget.value;
    audioEl.current.currentTime = value;
  };

  const onEnded = () => {
    setIsPlaying(false);
    seekBarEl.current.value = 0;
  };

  useEffect(() => {
    seekBarEl.current.value = 0;
    seekBarEl.current.min = audioEl.current.startTime;
    seekBarEl.current.max = audioEl.current.duration;

    const xhr = new XMLHttpRequest();
    xhr.onreadystatechange = event => {
      if (event.currentTarget.readyState === 4 && event.currentTarget.status === 200) {
        setCachedSource(window.URL.createObjectURL(event.currentTarget.response));
        setLoading(false);
      }
    };
    xhr.open('GET', `/recordings/${sid}`);
    xhr.responseType = 'blob';
    xhr.send();
  }, []);

  return (
    <div className="audio-player">
      <div className="wrapper">
        {loading ? (
          <div className="loading" />
        ) : (
          <button
            className="play-pause-btn"
            onClick={() => (loading ? null : onPlayButtonClick())}
          >
            <PlayPause isPlaying={isPlaying} />
          </button>
        )}

        <div className="controls">
          <input
            ref={seekBarEl}
            type="range"
            step="any"
            onChange={onSeekBarChange}
          />
          <span className="time-progress">
            {currentTime}/{duration}
          </span>
        </div>
        <audio
          src={cachedSource}
          ref={audioEl}
          onLoadedMetadata={onLoadedMetadata}
          onEnded={onEnded}
          onTimeUpdate={onTimeUpdate}
        />
      </div>
    </div>
  );
};

export default Recording;


Recording.propTypes = {
  sid: PropTypes.string.isRequired
};
